import { AxiosError } from 'axios';

type ApiErrorResponseData = { message?: string } | string;

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
    const axiosError = error as AxiosError<ApiErrorResponseData> | undefined;
    const data = axiosError?.response?.data;

    if (typeof data === 'string' && data) {
        return data;
    }

    if (data && typeof data === 'object' && typeof data.message === 'string') {
        return data.message;
    }

    if (error instanceof Error) {
        return error.message;
    }

    return fallback;
};
